import { MunicipalPropertyType } from "@/graphql/generated/graphql";

import { MunicipalPropertyCreateFormValues } from "./municipal-property-create-form-values";

export function buildEmptyMunicipalPropertyCreateForm(): MunicipalPropertyCreateFormValues {
  return {
    effectiveYear: new Date().getFullYear(),
    name: "",
    type: MunicipalPropertyType.Administration,
    description: "",
    street: "",
    houseNumber: "",
    postalCode: "",
    city: "",
    usableFloorAreaM2: null,
    commissioningYear: null,
    municipalityIdList: [],
  };
}
